import {
    SAVE_FOR_LATER_REQUEST,
    RESET_MOVE_SFL_CART_SUCCESS,
    VERTICAL_SFL_VIEW_ALL,
} from '../actionTypes/CartActionTypes';

export const saveForLaterCartItem = (payload) => ({
    type: SAVE_FOR_LATER_REQUEST,
    payload,
});

export const resetSflToCartSuccess = () => ({
    type: RESET_MOVE_SFL_CART_SUCCESS,
});

export const showVerticalSflViewAll = (payload) => ({
    type: VERTICAL_SFL_VIEW_ALL,
    payload,
});

export default {
    saveForLaterCartItem,
    resetSflToCartSuccess,
    showVerticalSflViewAll,
};
